import { useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { allowEndDeeplinkOnBackNav } from '#/redux/modules/lifecycle/actions';
import { getDeepLinkStarted } from '#/redux/modules/lifecycle/selectors';

export const useIsInitialDeeplink = location => {
  const dispatch = useDispatch();
  const deepLinkStarted = useSelector(getDeepLinkStarted);
  const initial = location?.state?.initialDeeplink || false;

  useEffect(() => {
    if (!deepLinkStarted) {
      return;
    }
    // Enable calling exitDeeplinkWorkflow on navigation back listener in Route.js
    dispatch(allowEndDeeplinkOnBackNav(deepLinkStarted && initial));
  }, [deepLinkStarted, initial, location]);

  return deepLinkStarted && initial;
};
